import React, { Component } from 'react';
import { Col, Row, Form, Button, Collapse } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLock } from '@fortawesome/free-solid-svg-icons';
import { PulseLoader } from 'react-spinners';
import Input from '../../../Input';
import './primerFactor.css';
import { isEmpty, isAlphanumeric, isMinLengthOk } from '../../../../utils/ValidationUtil';

class PrimerFactor extends Component {

  handleValidateClick = e => {
    e.preventDefault();
    const { validateChallenge, challengeResponse, changeErrorMessage } = this.props;
    if (isEmpty(challengeResponse)) {
      changeErrorMessage("El campo no puede estar vacío");
    } else if (!isAlphanumeric(challengeResponse)) {
      changeErrorMessage("El campo sólo debe contener letras y números");
    } else if (!isMinLengthOk(challengeResponse)) {
      changeErrorMessage("La clave debe tener al menos 6 dígitos");
    } else {
      validateChallenge(challengeResponse);
    }
  };

  render() {

    const { isLoading, errorInput, operation, errorMessage, changeErrorMessage, challengeResponse } = this.props;

    if (!errorInput) {
      changeErrorMessage("La clave ingresada es incorrecta. Favor intente nuevamente");
    }

    return (
      <Row>
        <Col className="primer-factor">
          <h6>
            Ingresa tu clave para confirmar la operación <b>{operation}</b>:

          </h6>
          <Form>
            <Form.Group
              as={Row}
              controlId="internetPass"
              className="justify-content-center"
            >
              <Col md={2} sm={2} xs={12}>
                <FontAwesomeIcon icon={faLock} />
              </Col>
              <Col md={6} sm={6} xs={6}>
                <Input
                  value={challengeResponse}
                  maxLength={8}
                  width="100%"
                  helpText="Clave de Internet"
                  onChange={e => {
                    const { changeChallengeResponse } = this.props;
                    changeChallengeResponse(e.target.value.trim());
                  }}
                  onFocus={() => {
                    const { removeError, changeErrorMessage } = this.props;
                    changeErrorMessage("");
                    removeError();
                  }}
                  type="password"
                  errorText={errorMessage}
                />
              </Col>
            </Form.Group>
            <Collapse in={isLoading}>
              <div className="dap_loader-center">
                <PulseLoader size={20} color="#d64b36" />
              </div>
            </Collapse>
            <Button
              type="submit"
              onClick={this.handleValidateClick}
              className="dap_btn-primary"
            >
              Validar
            </Button>
          </Form>
        </Col>
      </Row>
    );
  }
}

export default PrimerFactor;
